/**
 * AnimationClipCache - singleton for sharing THREE.AnimationClip instances by name.
 * Stores clips so animations from separate models can reuse memory.
 */
import { EngineClass } from '../systems/ClassRegistry.js';

import type * as THREE from 'three';

@EngineClass('AnimationClipCache')
export class AnimationClipCache {
  private static _instance: AnimationClipCache | null = null;
  private clipMap: Map<string, THREE.AnimationClip> = new Map();

  public static get instance(): AnimationClipCache {
    this._instance ??= new AnimationClipCache();
    return this._instance;
  }

  public addClip(clip: THREE.AnimationClip): void {
    this.clipMap.set(clip.name, clip);
  }

  public addClips(clips: THREE.AnimationClip[]): void {
    for (const clip of clips) {
      this.addClip(clip);
    }
  }

  public getClip(name: string): THREE.AnimationClip | undefined {
    return this.clipMap.get(name);
  }

  public hasClip(name: string): boolean {
    return this.clipMap.has(name);
  }

  public removeClip(name: string): void {
    this.clipMap.delete(name);
  }

  public clear(): void {
    this.clipMap.clear();
  }

  public getClipNames(): string[] {
    return Array.from(this.clipMap.keys());
  }
}